/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface KundeProjektleiterControllerGetProjektleiterProfilbildV1$Params {
}

export function kundeProjektleiterControllerGetProjektleiterProfilbildV1(http: HttpClient, rootUrl: string, params?: KundeProjektleiterControllerGetProjektleiterProfilbildV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, kundeProjektleiterControllerGetProjektleiterProfilbildV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'image/webp', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

kundeProjektleiterControllerGetProjektleiterProfilbildV1.PATH = '/v1/kunden/projektleiter/profilbild';
